/**
 * Api_endpoints
 *
 * Centralized configuration of all API endpoint paths used by the application.
 */
/**
 * API endpoints for the application.
 *
 * This module contains the various API endpoints used for authentication,
 * registration, and management of farmers within the application.
 */
export const apiEndpoints = {
  /**
   * Endpoints for Farmer authentication.
   */
  auth: {
    /**
     * Endpoint to submit login or verification challenge.
     *
     * @example
     * POST /auth/challenge/
     */
    submitChallenge: "challenge/",

    /**
     * Check if an email is registered or allowed.
     *
     * @example
     * GET /auth/verify-link-login/
     */
    verifyLinkLogin: "verify-link-login/",
  },

  /**
   * Endpoints for Farmer registration and management.
   */
  farmerRegister: {
    /**
     * This is a part of API URL's for events.
     *
     * @example
     * GET /farmerRegister/events/
     */
    events: "/events/",

    /**
     * This endpoint retrieves the available registration types for a specific event.
     *
     * @example
     * GET /farmerRegister/register_types/
     */
    registerTypes: "/register_types/",

    /**
     * This endpoint allows users to register for a paid event by submitting the necessary registration details.
     *
     * @example
     * POST /farmerRegister/paid/register/
     */
    getAddRegistrationDetails: "/paid/register/",


    /**
     * This endpoint initializes a payment process using Razorpay for a specific event registration.
     */
    initiateRazorpayPayment: "/payment/razorpay/init",

    /**
     * This endpoint verifies Razorpay payment for event registrations.
     */
    verifyRazorpayPayment: "/payment/razorpay/success",

    /**
     * This endpoint handles failed payment scenarios for event registrations.
     *
     * @example
     * POST /farmerRegister/razorpay_payment_failed/
     */
    failurePayment: "/payment/razorpay/failed",

    /**
     * This endpoint retrieves the ticket information for a specific event associated with a farmer's account.
     *
     * @example
     * GET /farmerRegister/tickets/
     */
    tickets: "/tickets/",


    /**
     * This endpoint assigns a ticket to a user.
     *
     * @example
     * POST /farmerRegister/assign
     */
    assign: "/assign",

    /**
     * This endpoint retrieves the upload link for ticket images.
     *
     * @example
     * GET /farmerRegister/ticket_image_upload_link
     */
    ticket_image_upload_link: "/ticket_image_upload_link",

    /**
     * This endpoint retrieves the status of a specific event for a given user.
     *
     * @example
     * GET /farmerRegister/status
     */
    status: "/status",

    /**
     * This endpoint retrieves suggestions related to a specific event for a given farmer.
     *
     * @example
     * GET /farmerRegister/suggestions
     */
    suggestions: "/suggestions",

    /**
     * Endpoint to update the basic profile information of a farmer.
     *
     * @example
     * PUT /farmerRegister/profile/basic
     */
    profile: "/profile/basic",

    /**
     * Endpoint to get profile picture upload link.
     *
     * @example
     * GET /farmerRegister/profile/profile_pic_upload_link
     */
    profile_pic_upload_link: "/profile/profile_pic_upload_link",

    /**
     * This endpoint allows you to check the email verification status of a user's profile.
     *
     * @example
     * GET /farmerRegister/profile/check_email_status
     */
    check_email_status: "/profile/check_email_status",

    /**
     * Endpoint to initiate Razorpay payment for ticket upgrade.
     */
    initiateUpgradePayment: "/upgrade/payment/razorpay/init",

    /**
     * Endpoint to verify Razorpay payment for ticket upgrade.
     */
    verifyUpgradePayment: "/upgrade/payment/razorpay/success",


    /**
     * Endpoint to handle failed upgrade payment scenarios.
     *
     * @example
     * POST /farmerRegister/upgrade/payment/razorpay/failed/
     */
    failedUpgradePayment: "/upgrade/payment/razorpay/failed",

    /**
     * Endpoint for exhibitor invitation.
     *
     * @example
     * GET /farmerRegister/exh_invite
     */
    exhInvite: "/exh-invites/",

    /**
     * Endpoint to accept an invitation.
     *
     * @example
     * POST /farmerRegister/accept
     */
    acceptInvite: "/accept",

    exhInvitePendingList: "/exh-invites/pending",
    language: "en",
    source: "web",

    virtual_visitor_register: "/virtual/register",
    ticketImageUploadLink: "ticket_image_upload_link",
    updateUploadTicketMedia: "/image",
  },

  categories: {
    /** GET    /categories/             → retrieve all top-level categories */
    getAllCategories: "categories/",
    /** PUT    /categories/             → update user's selected categories */
    updateCategories: "/profile/categories",

  },

  farmerDigitalCatalog: {
    /** This is a part of api url's*/
    events: "events/",
    /** Endpoint to get pavilion list */
    pavilions: "/catalog/pavilions",
    /** Endpoint to get products list */
    products: "/catalog/products",
    /** Endpoint to save user activity */
    activity: "/catalog/activity",
    /** Endpoint to get companies list */
    companies: "/catalog/companies",
    /** Endpoint to get Ads list */
    ads: "/catalog/ads",
    /** Endpoint to save Ads activity */
    adsactivity: "/catalog/activity/ads",
  },

  voting: {
    /** Endpoint to get contest participants */
    contests: "/contests/",
    /** Endpoint to get vote status */
    votestatus: "/vote_status/",
    /** Endpoint to get contest participants */
    participants: "/participants/",
    /** Endpoint to cast a vote */
    vote: "/vote",
    /** Endpoint to log contest activity */
    activity: "/activity",
  }

};
